var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { Availability } from "../Availability";
import { CustomParameterInstanceAvailabilityService } from "./CustomParameterInstanceAvailabilityService";
import { ModifierInstanceAvailabilityService } from "./ModifierInstanceAvailabilityService";
let ProductConfigAvailabilityService = class ProductConfigAvailabilityService {
    constructor(customParameterInstanceAvailabilityService, modifierInstanceAvailabilityService) {
        this.customParameterInstanceAvailabilityService = customParameterInstanceAvailabilityService;
        this.modifierInstanceAvailabilityService = modifierInstanceAvailabilityService;
        makeImmutable(this);
    }
    availability(productConfig) {
        const modifierAvailabilities = productConfig.modifierInstances.objects.map((modifierInstance) => this.modifierInstanceAvailabilityService.availability(modifierInstance));
        const customParameterAvailabilities = productConfig.customParameterInstances.objects.map((customParameterInstance) => this.customParameterInstanceAvailabilityService.availability(customParameterInstance));
        return Availability.composite([
            Availability.dependent("ModifierInstance", "", Availability.composite(modifierAvailabilities.raw)),
            Availability.dependent("CustomParameterInstance", "", Availability.composite(customParameterAvailabilities.raw)),
        ]);
    }
};
ProductConfigAvailabilityService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof CustomParameterInstanceAvailabilityService !== "undefined" && CustomParameterInstanceAvailabilityService) === "function" ? _a : Object, typeof (_b = typeof ModifierInstanceAvailabilityService !== "undefined" && ModifierInstanceAvailabilityService) === "function" ? _b : Object])
], ProductConfigAvailabilityService);
export { ProductConfigAvailabilityService };
